import React, { useContext } from "react";
import {
  Card,
  ContactDetails,
  ContactInfoTop,
  ContactInfoBottom,
  Container,
  ContactGrid,
  Text,
  ContactImage,
  ContactName,
  CompanyName,
  ContactWrapper,
} from "./styles";
import { RefContext } from "../AppContext";
import data from "./data.json";
import CTAButton from "../../common/CTAButton";
import useIsMobile from "../../common/hooks/useIsMobile";
import { Flex } from "../../common/Layouts/styles";

const Contact = () => {
  const { contactBlockRef } = useContext(RefContext);
  const isMobile = useIsMobile();

  return (
    <Container ref={contactBlockRef}>
      <ContactGrid
        cols={
          !isMobile ? "repeat(2, minmax(100px, 1fr))" : "minmax(100px, 1fr)"
        }
      >
        <Card direction="column" justify="space-between">
          <CompanyName>{data.company.name}</CompanyName>
          <Flex direction="column">
            <ContactWrapper>
              <ContactInfoBottom gap={!isMobile ? "1vw" : "3vw"}>
                <ContactImage
                  src={require("../../content/assets/vitalii.png")}
                  alt="Vitalii"
                />
                <ContactDetails gap={!isMobile ? "1vw" : "1.4vw"}>
                  <ContactName>{data.contactPerson.name}</ContactName>
                  <a style={{ display: "flex" }} href="https://t.me/disidend">
                    <CTAButton
                      fontSize={!isMobile ? ".8vw" : "3vw"}
                      padding={!isMobile ? ".2vw .4vw" : "0 .8vw"}
                      arrowSize={!isMobile ? ".7vw" : "2.4vw"}
                      ellipsePadding={!isMobile ? ".8vw" : "3vw"}
                      style={{ width: "100%" }}
                      flexGrow={1}
                    >
                      {data.contactPerson.action}
                    </CTAButton>
                  </a>
                </ContactDetails>
              </ContactInfoBottom>
              <ContactInfoBottom gap={!isMobile ? "1vw" : "3vw"}>
                <ContactImage
                  src={require("../../content/assets/anna.png")}
                  alt="Vitalii"
                />
                <ContactDetails gap={!isMobile ? "1vw" : "1.4vw"}>
                  <ContactName>{data.contactPerson.assistant}</ContactName>
                  <a style={{ display: "flex" }} href="tel:+7 (999) 536-48-29">
                    <CTAButton
                      fontSize={!isMobile ? ".8vw" : "3vw"}
                      padding={!isMobile ? ".2vw .4vw" : "0 .8vw"}
                      arrowSize={!isMobile ? ".7vw" : "2.4vw"}
                      ellipsePadding={!isMobile ? ".8vw" : "3vw"}
                      style={{ width: "100%" }}
                      flexGrow={1}
                    >
                      {data.contactPerson.call}
                    </CTAButton>
                  </a>
                </ContactDetails>
              </ContactInfoBottom>
              <ContactInfoBottom gap={!isMobile ? "1vw" : "3vw"}>
                <ContactImage
                  src={require("../../content/assets/alex.png")}
                  alt="Vitalii"
                />
                <ContactDetails gap={!isMobile ? "1vw" : "1.4vw"}>
                  <ContactName>{data.contactPerson.cvo}</ContactName>
                  <a style={{ display: "flex" }} href="https://t.me/gostaleks">
                    <CTAButton
                      fontSize={!isMobile ? ".8vw" : "3vw"}
                      padding={!isMobile ? ".2vw .4vw" : "0 .8vw"}
                      arrowSize={!isMobile ? ".7vw" : "2.4vw"}
                      ellipsePadding={!isMobile ? ".8vw" : "3vw"}
                      style={{ width: "100%" }}
                      flexGrow={1}
                    >
                      {data.contactPerson.action}
                    </CTAButton>
                  </a>
                </ContactDetails>
              </ContactInfoBottom>
              <ContactInfoBottom gap={!isMobile ? "1vw" : "3vw"}>
                <ContactImage
                  src={require("../../content/assets/sultan.png")}
                  alt="Vitalii"
                />
                <ContactDetails gap={!isMobile ? "1vw" : "1.4vw"}>
                  <ContactName>{data.contactPerson.cmo}</ContactName>
                  <a style={{ display: "flex" }} href="https://t.me/Khasanov_Sultan">
                    <CTAButton
                      fontSize={!isMobile ? ".8vw" : "3vw"}
                      padding={!isMobile ? ".2vw .4vw" : "0 .8vw"}
                      arrowSize={!isMobile ? ".7vw" : "2.4vw"}
                      ellipsePadding={!isMobile ? ".8vw" : "3vw"}
                      style={{ width: "100%" }}
                      flexGrow={1}
                    >
                      {data.contactPerson.action}
                    </CTAButton>
                  </a>
                </ContactDetails>
              </ContactInfoBottom>
            </ContactWrapper>
            <ContactInfoTop>
              <Text>{data.company.details.INN}</Text>
              <Text>{data.company.details.address}</Text>
            </ContactInfoTop>
            <ContactInfoTop>
              <Text>{data.company.details.email}</Text>
            </ContactInfoTop>
          </Flex>
        </Card>
        <img
          width={"100%"}
          height={"100%"}
          src={require("../../content/assets/map.png")}
          style={{objectFit: "cover"}}
          alt="Map"
        />
      </ContactGrid>
    </Container>
  );
};

export default Contact;
